import { useMemo } from "react";
import { ensureArray } from "../common/utils/arrayUtilities";
import { useNavigate } from "../common/hooks/navigateHook";

export const excludedTypes = ['label', 'object', 'iframe', 'button', 'signature', 'file', 'computed']; // TODO add computed back when customctrl/datatable can handle it

const base = process.env.NODE_ENV === 'production' ? '/ora/' : '/'

export const usePageNav = () => {
    const navigate = useNavigate();

    return useMemo(() => ({
        navigateToSearchResultItem: (path, id, event) => {
            event?.stopPropagation();
            event?.preventDefault();
            let dest = path;
            if (id) {
                dest += encodeURIComponent(id);
            }
            if (event?.ctrlKey || event?.metaKey) {
                window.open(base + '/' + dest, '_blank');
            } else {
                navigate('/' + dest);
            }
        },
        navigateBackToSearchPage: (path, event) => {
            event?.stopPropagation();
            event?.preventDefault();
            navigate('/' + path)
        },
        navigateToNewItemPage: (path, event) => {
            event?.stopPropagation();
            event?.preventDefault();
            if (event?.ctrlKey || event?.metaKey) {
                window.open(base + path, '_blank');
            } else {
                navigate('/' + path);
            }
        }
    }), [navigate]);
}

export const buildSearchQuery = (search) => {
    let data = {}
    Object.entries(search).forEach(([field, value]) => {
        if (value !== null && value !== '' && value !== undefined && !(typeof value === 'object' && Object.keys(value).length === 0)) {
            data[field] = value;
        }
    });
    return data;
}

const EMPTY_ARRAY = []

export const getCustomFieldDefs = (customfields) => {
    const customfieldFilter = (def) => !excludedTypes.includes(def.type) && def.label && def.field;
    
    if (!customfields) return EMPTY_ARRAY
    
    const formSpec = (JSON.parse(JSON.stringify(ensureArray(customfields))));
    const defs = formSpec?.flatMap(section => section.rows?.flatMap(row => row.filter(cell => customfieldFilter(cell)).map(cell => {
        const def = (JSON.parse(JSON.stringify(cell)))
        if (typeof cell.field === 'string') {
            def.field = 'customfields.'+ cell.field;
            def.title = cell.label;
        } else if (Array.isArray(cell.field)) {
            def.field = def.field.map(f => 'customfields.' + f);
            def.title = cell.label.default;
        } else {
            Object.keys(def.field).forEach(key => {
                def.field[key] = 'customfields.' + def.field[key];
            })
            def.title = cell.label.default;
        }
        return def;
    })) ?? EMPTY_ARRAY);

    return defs ?? EMPTY_ARRAY
}